import { usePermissions } from 'react-admin';
import { Access } from '../utils/access';

export const useResourceAccess = () => {
  const { permissions } = usePermissions();

  return permissions ?? Access(['unknown']);
};
